// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.

import { useIdleLogout } from './useIdleLogout'

/**
 * Renders the "are you still there?" prompt when a session is about to time out from inactivity.
 * Mounted once in AppShell; no-ops while the user is active or signed out.
 */
export default function IdleLogoutGuard() {
  const { warning, secondsLeft, stayActive, logoutNow } = useIdleLogout()
  if (!warning) return null
  return (
    <div role="alertdialog" aria-modal="true" aria-labelledby="idle-title" style={overlay}>
      <div style={modal}>
        <h2 id="idle-title" style={title}>Are you still there?</h2>
        <p style={body}>
          You'll be signed out in <strong>{secondsLeft}s</strong> to protect patient information on this
          screen. Any unsaved work should be saved.
        </p>
        <div style={actions}>
          <button onClick={logoutNow} style={secondary}>Sign out now</button>
          <button onClick={stayActive} style={primary} autoFocus>Stay signed in</button>
        </div>
      </div>
    </div>
  )
}

const overlay: React.CSSProperties = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const modal: React.CSSProperties = { background: '#fff', borderRadius: 14, padding: 28, maxWidth: 380, width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }
const title: React.CSSProperties = { fontSize: 19, fontWeight: 800, color: '#0f172a', margin: '0 0 10px' }
const body: React.CSSProperties = { fontSize: 14, color: '#475569', lineHeight: 1.6, margin: '0 0 22px' }
const actions: React.CSSProperties = { display: 'flex', gap: 10, justifyContent: 'flex-end' }
const secondary: React.CSSProperties = { fontSize: 14, fontWeight: 600, padding: '9px 16px', borderRadius: 8, border: '1px solid #cbd5e1', background: '#fff', color: '#475569', cursor: 'pointer' }
const primary: React.CSSProperties = { fontSize: 14, fontWeight: 600, padding: '9px 16px', borderRadius: 8, border: 'none', background: '#0891b2', color: '#fff', cursor: 'pointer' }
